var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "200px",
    height: "300px",
    viewBox: "0 0 200 300",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "placeholder") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Android-TV",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "placeholder"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "horizontal_placeholder",
    fill: "#202027",
    fillRule: "nonzero",
    x: 0,
    y: 0,
    width: 200,
    height: 300,
    rx: 3
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-14",
    opacity: 0.100000001,
    transform: "translate(100.500000, 150.500000) rotate(45.000000) translate(-100.500000, -150.500000) translate(78.000000, 125.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-14",
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 45,
    height: 51
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-48",
    fill: "#BEBEBE",
    x: 0,
    y: 25,
    width: 45,
    height: 26
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-49",
    fill: "#202027",
    x: 3,
    y: 45,
    width: 4,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-57",
    fill: "#202027",
    x: 38,
    y: 45,
    width: 4,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-50",
    fill: "#202027",
    x: 3,
    y: 36,
    width: 4,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-58",
    fill: "#202027",
    x: 38,
    y: 36,
    width: 4,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-51",
    fill: "#202027",
    x: 3,
    y: 27,
    width: 4,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-59",
    fill: "#202027",
    x: 38,
    y: 27,
    width: 4,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-52",
    fill: "#202027",
    x: 3,
    y: 18,
    width: 4,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-60",
    fill: "#202027",
    x: 38,
    y: 18,
    width: 4,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-53",
    fill: "#202027",
    x: 3,
    y: 9,
    width: 4,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-61",
    fill: "#202027",
    x: 38,
    y: 9,
    width: 4,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-54",
    fill: "#202027",
    x: 3,
    y: 0,
    width: 4,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-62",
    fill: "#202027",
    x: 38,
    y: 0,
    width: 4,
    height: 6
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceholder);
export default __webpack_public_path__ + "static/media/placeholder.4df6ba1d34e35a54e14ee878cab1040e.svg";
export { ForwardRef as ReactComponent };